/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import { PayloadAction } from "@reduxjs/toolkit";
import { IDasInventoryFilterState } from "./types";

export const setSelectedEquipmentTypeAction = (state: IDasInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedEquipmentType = action.payload;
};

export const setSelectedStatusAction = (state: IDasInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedStatus = action.payload;
};

export const setSelectedBandAction = (state: IDasInventoryFilterState, action: PayloadAction<string>) => {
  state.selectedBand = action.payload;
};

export const setSearchTextAction = (state: IDasInventoryFilterState, action: PayloadAction<string>) => {
  state.searchText = action.payload;
};

export const resetDasInventoryFiltersAction = (state: IDasInventoryFilterState) => {
  state.selectedEquipmentType = "";
  state.selectedStatus = "";
  state.selectedBand = "";
  state.searchText = "";
};
